<div class="description" translate="parameters/whatsapp-templates/category/description"></div>
<form [formGroup]="form">
  <mat-radio-group formControlName="category">
    <mat-radio-button *ngFor="let category of categories" [value]="category">
      <strong
        [attr.data-testid]="'category-option-' + category"
        [translate]="'parameters/whatsapp-templates/category/' + category + '/label'"></strong>
      <p [translate]="'parameters/whatsapp-templates/category/' + category + '/description'"></p>
    </mat-radio-button>
  </mat-radio-group>
</form>
